import React from "react";
import { Crosshair, Scale, BookOpen, Sword } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const values = [{
  title: "Disciplin",
  description: "Styrken til at gøre det nødvendige, selv når ingen ser det. Rygraden i enhver bedrift.",
  icon: Crosshair
}, {
  title: "Etik",
  description: "Det moralske kompas, der aldrig svigter i stormen. Sandheden over bekvemmelighed.",
  icon: Scale
}, {
  title: "Tro",
  description: "Fundamentet for al sand karakter. Et urokkeligt værn mod tidsåndens forfald.",
  icon: BookOpen
}, {
  title: "Mod",
  description: "Viljen til at stå fast, når andre falder fra. Handlekraft i mødet med modstand.",
  icon: Sword
}];
export default function MilitaryValues() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="militære-værdier" className="dark bg-background text-foreground py-20 px-4 md:py-32 relative overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none opacity-[0.03]" style={{
      backgroundImage: "linear-gradient(to right, #ffffff 1px, transparent 1px), linear-gradient(to bottom, #ffffff 1px, transparent 1px)",
      backgroundSize: "40px 40px"
    }} />

      <div className="container mx-auto max-w-6xl relative z-10" ref={ref}>
        <div className={cn("grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 border border-border bg-card/20 backdrop-blur-sm transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
          {values.map((item, i) => <div key={item.title} data-index={i} className={cn("group relative flex flex-col items-center text-center p-8 md:p-10 border-border", "border-b lg:border-b-0", i < values.length - 1 && "lg:border-r", i % 2 === 0 && "md:border-r lg:border-r", i === values.length - 2 && "md:border-b-0", i === values.length - 1 && "border-b-0")}>
              {}
              <div className="absolute inset-0 bg-primary/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

              {}
              <div className="relative mb-8">
                {}
                <div className="absolute inset-0 bg-primary/10 rotate-45 border border-primary/30 transition-transform duration-500 group-hover:rotate-90 group-hover:scale-110" />
                <div className="relative z-10 p-4">
                  <item.icon className="w-8 h-8 text-primary" strokeWidth={1.5} />
                </div>
                
                {}
                <div className="absolute -top-1 -left-1 w-2 h-2 border-t border-l border-primary/40" />
                <div className="absolute -bottom-1 -right-1 w-2 h-2 border-b border-r border-primary/40" />
              </div>

              {}
              <h3 className="text-lg font-bold uppercase tracking-widest mb-3 text-foreground font-sans">
                {item.title}
              </h3>
              <p className="text-sm text-muted-foreground leading-relaxed font-medium max-w-[240px]">
                {item.description}
              </p>

              {}
              <div className="absolute top-0 left-0 w-full h-full pointer-events-none">
                <div className="absolute top-2 left-2 w-3 h-3 border-t-2 border-l-2 border-primary opacity-0 group-hover:opacity-100 transition-all duration-300" />
                <div className="absolute bottom-2 right-2 w-3 h-3 border-b-2 border-r-2 border-primary opacity-0 group-hover:opacity-100 transition-all duration-300" />
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}